/* globals Class,jui,lp */
var _ = require('lodash');

;(function(){
  lp.editor.TransformBoxHandleHelper = Class.create({
    initialize: function(box, elm){
      this.box = box;
      this.elm = elm;
      this.model = elm.model;
      this.editor = box.editor;
      _.bindAll(this);

      var m = elm.model;
      this.elmStartRootOffset = elm.getRootOffset();
      this.elmStartOffset = m.getOffset();
      this.elmStartSize = m.getSize();
      this.elmMinSize = m.getMinSize();
      this.elmMaxSize = m.getMaxSize();
      this.elmStartScale = m.getScale();

      if (!box.undoRegistered) {
        //TODO: it appears that we might not need to do undoRegistered
        //unless inside the image transform handle. Review this later.
        box.undoRegistered = true;
        var um = elm.page.undoManager;
        um.startGroup();
        um.registerUndo({
          action:m.setOffset,
          receiver:m,
          params:[{left:this.elmStartOffset.left, top:this.elmStartOffset.top}, um]
        });
        um.registerUndo({
          action:m.setSize,
          receiver:m,
          params:[{width:this.elmStartSize.width, height:this.elmStartSize.height}, um]
        });
        um.registerUndo({
          action:m.setScale,
          receiver:m,
          params:[this.elmStartScale, um]
        });
        um.endGroup();
      }
    },

    _snapPoint: function(p, options) {
      this.editor.snapManager.snapPoint(p, options);
    },

    _maintainAR: function() {
      return this.model.isMaintainAR();
    },

    /* Description of some of the variable used in the following 8 TransformBoxHandles drag functions
    These methods are called by the corresponding TransformBoxHandles when they are dragged
    o = the offset from the drag start point. e.g. {left:0, top:0}
    w0 = initial width before the start of the drag operation
    h0 = initial height before the start of the drag operation
    * note these last two are just short hand for this.elmStartSize.width and this.elmStartSize.height
    * this.elmStartSize is just set once at the begiing of the drag operation
    w,h,l,t = final values for width, height, top and left after adjustments for minSize, maxSize and isMaintainAR (aspect ratio)
    minSize = element min size
    maxize = element max size
    * also these to are just short hand for the values already obtained at the start of teh drag operation in handleDragStart
    ar = aspect ration
    d = start distance from page root of the corner or side that the handle corresponds to
    p = final point that the corner or side should be moved to (this is adjusted for snap points)
*/

    handleDragTopLeft: function(o) {
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var w,h,l,t;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var d = {left: this.elmStartRootOffset.left, top: this.elmStartRootOffset.top};
      var p = {left: d.left + o.left, top: d.top + o.top};

      this._snapPoint(p);

      p.left -= d.left;
      p.top -= d.top;

      if (this._maintainAR()) {
        p = jui.Point.intersectionWithSlope(p, w0, h0);
      }

      w = Math.min(maxSize.width, Math.max(minSize.width, w0 - p.left));
      h = Math.min(maxSize.height, Math.max(minSize.height, h0 - p.top));

      if (this._maintainAR()) {
        if  (w === maxSize.width || w === minSize.width) {
          h = Math.min(maxSize.height, Math.max(minSize.height, Math.round(w / ar)));
        }

        if  (h === maxSize.height || h === minSize.height) {
          w = Math.min(maxSize.width, Math.max(minSize.width, Math.round(h * ar)));
        }
      }

      l = this.elmStartOffset.left + (w0 - w);
      t = this.elmStartOffset.top + (h0 - h);
      this._updateModelAfterDragTopLeft({width:w, height:h, left:l, top:t});
    },

    _updateModelAfterDragTopLeft: function(args) {
      this.model.suppressEvents();
      this.model.setSize({width:args.width, height:args.height});
      this.model.setOffset({left:args.left, top:args.top});
      this.model.releaseEvents();

    },

    handleDragTopRight: function(o) {
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var w,h,t;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var d = {left: this.elmStartRootOffset.left + w0, top: this.elmStartRootOffset.top};
      var p = {left: d.left + o.left, top: d.top + o.top};

      this._snapPoint(p);

      p.left -= d.left;
      p.top -= d.top;

      if (this._maintainAR()) {
        jui.Point.intersectionWithSlope(p, w0, -h0);
      }

      w = Math.min(maxSize.width, Math.max(minSize.width, w0 + p.left));
      h = Math.min(maxSize.height, Math.max(minSize.height, h0 - p.top));

      if (this._maintainAR()) {
        if  (w === maxSize.width || w === minSize.width) {
          h = Math.min(maxSize.height, Math.max(minSize.height, Math.round(w / ar)));
        }

        if  (h === maxSize.height || h === minSize.height) {
          w = Math.min(maxSize.width, Math.max(minSize.width, Math.round(h * ar)));
        }
      }

      t = this.elmStartOffset.top + (h0 - h);

      this._updateModelAfterDragTopRight({
        width:w,
        height:h,
        top:t});
    },

    _updateModelAfterDragTopRight: function(args) {
      this.model.suppressEvents();
      this.model.setSize({width:args.width, height:args.height});
      this.model.setTop(args.top);
      this.model.releaseEvents();
    },

    handleDragBottomLeft: function(o) {
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var w,h,l;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var d = {left: this.elmStartRootOffset.left, top: this.elmStartRootOffset.top + h0};
      var p = {left: d.left + o.left, top: d.top + o.top};

      this._snapPoint(p);

      p.left -= d.left;
      p.top -= d.top;

      if (this._maintainAR()) {
        jui.Point.intersectionWithSlope(p, -w0, h0);
      }

      w = Math.min(maxSize.width, Math.max(minSize.width, w0 - p.left));
      h = Math.min(maxSize.height, Math.max(minSize.height, h0 + p.top));

      if (this._maintainAR()) {
        if  (w === maxSize.width || w === minSize.width) {
          h = Math.min(maxSize.height, Math.max(minSize.height, Math.round(w / ar)));
        }

        if  (h === maxSize.height || h === minSize.height) {
          w = Math.min(maxSize.width, Math.max(minSize.width, Math.round(h * ar)));
        }
      }

      l = this.elmStartOffset.left + (w0 - w);

      this._updateModelAfterDragBottomLeft({width:w, height:h, left:l});
    },

    _updateModelAfterDragBottomLeft: function(args) {
      this.model.suppressEvents();
      this.model.setSize({width:args.width, height:args.height});
      this.model.setLeft(args.left);
      this.model.releaseEvents();
    },

    handleDragBottomRight: function(o) {
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var w,h;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var d = {left: this.elmStartRootOffset.left + w0, top: this.elmStartRootOffset.top + h0};
      var p = {left: d.left + o.left, top: d.top + o.top};

      this._snapPoint(p);

      p.left -= d.left;
      p.top -= d.top;

      if (this._maintainAR()) {
        jui.Point.intersectionWithSlope(p, w0, h0);
      }

      w = Math.min(maxSize.width, Math.max(minSize.width, w0 + p.left));
      h = Math.min(maxSize.height, Math.max(minSize.height, h0 + p.top));

      if (this._maintainAR()) {
        if  (w === maxSize.width || w === minSize.width) {
          h = Math.min(maxSize.height, Math.max(minSize.height, Math.round(w / ar)));
        }

        if  (h === maxSize.height || h === minSize.height) {
          w = Math.min(maxSize.width, Math.max(minSize.width, Math.round(h * ar)));
        }
      }

      this._updateModelAfterDragBottomRight({width: w, height: h});
    },

    _updateModelAfterDragBottomRight: function(args) {
      this.model.suppressEvents();
      this.model.setSize({width:args.width, height:args.height});
      this.model.releaseEvents();
    },

    handleDragLeft: function(o) {
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var w,h,l;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var d = {left: this.elmStartRootOffset.left, top:0};
      var p = {left: d.left + o.left, top:0};

      this._snapPoint(p, {y:false});

      p.left -= d.left;

      w = Math.min(maxSize.width, Math.max(minSize.width, w0 - Math.round(p.left)));
      if (this._maintainAR()) {
        h = Math.round(w / ar);
        if (h >= maxSize.height || h <= minSize.height) {
          h = Math.min(maxSize.height, Math.max(minSize.height, h));
          w = Math.min(maxSize.width, Math.max(minSize.width, Math.round(h * ar)));
        }
      } else {
        h = h0;
      }

      l = this.elmStartOffset.left + Math.round((w0 - w));

      this._updateModelAfterDragLeft({width: w, height: h, left: l});
    },

    _updateModelAfterDragLeft: function(args) {
      this.model.suppressEvents();
      this.model.setSize({width:args.width, height:args.height});
      this.model.setLeft(args.left);
      this.model.releaseEvents();
    },

    handleDragTop: function(o) {
      var m = this.model;
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var w,h,t;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var d = {left: 0, top: this.elmStartRootOffset.top};
      var p = {left: 0, top: d.top + o.top};

      this._snapPoint(p, {x:false});

      p.top -= d.top;

      h = Math.min(maxSize.height, Math.max(minSize.height, h0 - p.top));
      if (this._maintainAR()) {
        w = Math.round(h * ar);
        if (w >= maxSize.width || w <= minSize.width) {
          w = Math.min(maxSize.width, Math.max(minSize.width, w));
          h = Math.min(maxSize.height, Math.max(minSize.height, Math.round(w / ar)));
        }
      } else {
        w = w0;
      }

      w = m.isMaintainAR() ? Math.round(h / (h0 / w0)) : w0;
      t = this.elmStartOffset.top + (h0 - h);

      this._updateModelAfterDragTop({width: w, height: h, top: t});
    },

    _updateModelAfterDragTop: function(args) {
      this.model.suppressEvents();
      this.model.setSize({width:args.width, height:args.height});
      this.model.setTop(args.top);
      this.model.releaseEvents();
    },

    handleDragRight: function(o) {
      var m = this.model;
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var w,h;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var d = {left: this.elmStartRootOffset.left + Math.round(w0), top: 0};
      var p = {left: d.left + o.left, top: 0};

      this._snapPoint(p, {y:false});

      p.left -= d.left;

      w = Math.min(maxSize.width, Math.max(minSize.width, w0 + Math.round(p.left)));
      if (this._maintainAR()) {
        h = Math.round(w / ar);
        if (h >= maxSize.height || h <= minSize.height) {
          h = Math.min(maxSize.height, Math.max(minSize.height, h));
          w = Math.min(maxSize.width, Math.max(minSize.width, Math.round(h * ar)));
        }
      } else {
        h = h0;
      }

      m.suppressEvents();
      m.setSize({width:w, height:h});
      m.releaseEvents();

      this._updateModelAfterDragRight({width: w, height: h});
    },

    _updateModelAfterDragRight: function(args) {
      this.model.suppressEvents();
      this.model.setSize({width:args.width, height:args.height});
      this.model.releaseEvents();
    },

    handleDragBottom: function(o) {
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var w,h;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var d = {left: 0, top: this.elmStartRootOffset.top + h0};
      var p = {left: 0, top: d.top + o.top};

      this._snapPoint(p, {x:false});

      p.top -= d.top;

      h = Math.min(maxSize.height, Math.max(minSize.height, h0 + p.top));
      if (this._maintainAR()) {
        w = Math.round(h * ar);
        if (w >= maxSize.width || w <= minSize.width) {
          w = Math.min(maxSize.width, Math.max(minSize.width, w));
          h = Math.min(maxSize.height, Math.max(minSize.height, Math.round(w / ar)));
        }
      } else {
        w = w0;
      }

      this._updateModelAfterDragBottom({width: w, height: h});
    },

    _updateModelAfterDragBottom: function(args) {
      this.model.suppressEvents();
      this.model.setSize({width:args.width, height:args.height});
      this.model.releaseEvents();
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/transform_box_handle_helper.js
// module id = 1028
// module chunks = 0